/**
 * A utility to serialize error
 * @param error Error object to serialize
 */
export const serializeError = (error: Error): SerializedError => {
  return JSON.stringify(error, Object.getOwnPropertyNames(error));
};

/**
 * A utility to deserialize error strings
 * @param errorString serialized error. Incase JSON parse fails on errorString,
 * this will be used as message for new error object
 */
export const deserializeError = (errorString: SerializedError): Error => {
  try {
    const parsedError = JSON.parse(errorString);
    let error = new Error();

    /**
     * This is the equivalent of  Object.assign(error, parsedError),
     * But Object.assign is not supported in I.E 11
     */
    Object.entries(parsedError).map(([key, value]) => {
      error = Object.defineProperty(error, key.toString(), { value });
    });

    return error;
  } catch {
    return new Error(errorString);
  }
};

/**
 * Standard type alias for serialized error
 */
export type SerializedError = string;
